// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__KRzI5","inputWrap":"CustomTip_inputWrap__1tqSo"};